import { useEffect } from "react";
import { fontFaceCss, fontsUrl } from "../data/brand";

// Loads a branding font: a Google Fonts stylesheet, or @font-face rules for
// the company's own font files. One element per `id`, replaced when the font
// changes (the admin preview changes it while the admin types). Geist is
// loaded by usePublicFont() already.
const useBrandFont = (font, id = "trust-center-brand-font") => {
  const css = fontFaceCss(font);
  const url = !css && font && font.key !== "geist" ? fontsUrl([font]) : null;
  useEffect(() => {
    document.getElementById(id)?.remove();
    if (!css && !url) return undefined;
    let element;
    if (css) {
      element = document.createElement("style");
      element.textContent = css;
    } else {
      element = document.createElement("link");
      element.rel = "stylesheet";
      element.href = url;
    }
    element.id = id;
    document.head.appendChild(element);
    return () => element.remove();
  }, [id, css, url]);
};

export default useBrandFont;
